import { UserDashboardParametersDto } from './user-dashboard-parameters-dto';

export class UserDashboardByCommunityParametersDto extends UserDashboardParametersDto {
    workArea: string;

    getQueryString(): string {
        const tokens = [
            `workArea=${this.workArea}`,
            `userId=${this.userId}`,
            `includeAll=${this.includeAll}`,
            `clearCache=${this.clearCache}`
        ];
        return tokens.join('&');
    }
}
